/**
 * Inventory enums - SOURCE OF TRUTH
 * Pure TypeScript - no Drizzle imports
 */
// Product measure unit labels. Spelled out rather than abbreviated — these are
// only ever shown in the product form's picker, where "ml" next to "l" next to
// "fl oz" is easy to misread.
export const productMeasureUnitLabels = {
    ml: 'Millilitres',
    l: 'Litres',
    fl_oz: 'Fluid ounces',
    g: 'Grams',
    kg: 'Kilograms',
    gal: 'Gallons',
    oz: 'Ounces',
    lb: 'Pounds',
    cm: 'Centimetres',
    ft: 'Feet',
    in: 'Inches',
    whole: 'Whole item',
};
export const productMeasureUnitValues = Object.keys(productMeasureUnitLabels);
// Stock order status labels
export const stockOrderStatusLabels = {
    draft: 'Draft',
    ordered: 'Ordered',
    partially_received: 'Partially Received',
    received: 'Received',
    cancelled: 'Cancelled',
};
export const stockOrderStatusValues = Object.keys(stockOrderStatusLabels);
// Stock order fee type labels
export const stockOrderFeeTypeLabels = {
    currency: 'Fixed Amount',
    percent: 'Percentage',
};
export const stockOrderFeeTypeValues = Object.keys(stockOrderFeeTypeLabels);
// Stock take status labels
export const stockTakeStatusLabels = {
    in_progress: 'In Progress',
    completed: 'Completed',
    cancelled: 'Cancelled',
};
export const stockTakeStatusValues = Object.keys(stockTakeStatusLabels);
//# sourceMappingURL=inventory.js.map